<template>
    <div class="navigation">
        <div>
            <nav>
                <ul class="pagination">
                    <li
                        class="page-item"
                        :class="{ 'active' : currentPeriod == 2}"  @click="goToPeriod(2)"
                    >
                        <a class="page-link" href="javascript: void(0)">3 Месяца</a>
                    </li>
                    <li
                          class="page-item"
                          :class="{ 'active' : currentPeriod == 3}"  @click="goToPeriod(3)"
                      >
                          <a class="page-link" href="javascript: void(0)">6 Месяца</a>
                      </li>
                    <li
                          class="page-item"
                          :class="{ 'active' : currentPeriod == 4}"  @click="goToPeriod(4)"
                      >
                          <a class="page-link" href="javascript: void(0)">1 Год</a>
                      </li>
                    <li
                          class="page-item"
                          :class="{ 'active' : currentPeriod == 5}"  @click="goToPeriod(5)"
                      >
                          <a class="page-link" href="javascript: void(0)">Все время</a>
                      </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        name: "periodSwitcher",
        props: {
            currentPeriod: Number,
            goToPeriod: Function
        }
    }
</script>

<style scoped>
    .navigation div {
        float: left;
    }
    .navigation nav {
        float: right;
    }
    .navigation span {
        padding-right: 30px;
    }
    .navigation {
        line-height: 2.4;
    }
    .brand .datepicker {
        height: 31px !important;
    }
    .navigation .export-nav {
        float: right;
    }
    .pagination-onpage {
        padding-right: 30px;
    }
</style>